module.exports = __webpack_public_path__ + "img/SimplifyMyCareerLogo.c5b4ae07.jpg";